import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactQuill from 'react-quill'; // ES6
import 'react-quill/dist/quill.snow.css';
import { Dialog } from '@tempmee/react';
import Compressor from 'compressorjs';
import NPSInfo from './NPSInfo';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import EditTab from '../Job/Edits/EditTab';
import NotesTab from './NotesCard';
import { LegacyDialogBody } from '../../commonComponents/LegacyDialogBody';
import ChildOffices from './ChildOffices';

import Styles from '../../../themes/style.module.scss';
import BlockedHygienist from './BlockedHygienist';
import ProfileHygienistGeneralInfo from './ProfileHygienistGeneralInfo';
import ProfileDentistGeneralInfo from './ProfileDentistGeneralInfo';

import CustomPaymentMethodsList from '../../commonComponents/CustomPaymentMethodsList';
import { UserPPJobList } from '../../commonComponents/UserPPJobList';
import NotificationSettings from '../../commonComponents/NotificationSettings';
import FavoritesList from '../../commonComponents/FavoritesList';
import NotificationSettingsHYG from '../../commonComponents/NotificationSettingsHYG';
import { UserJobList } from '../../commonComponents/UserJobList/UserJobList';
import { UserOfferList } from '../../commonComponents/UserOfferList';

import {
  addUserNote,
  deleteCurrentUser,
  fetchChildOffices,
  fetchCurrentUser,
  fetchProfessionalStats,
  fetchSpecificUser,
  fetchUserNotes,
  fetchUsersAround,
  getUserOffers,
  getUserReceipts,
  resetUserPassword,
  sendEmail,
  sendUserMFA,
  setCurrentUser,
  updateAccountStanding,
  updateCurrentUser,
  updateCurrentUserPayment,
  updateRamVerifiedStatus,
  updateUserAvatar,
  updateUserPicture,
} from '../../../actions/userActions';

import { fetchStateCredentials } from '../../../actions/licensesAction';

import {
  getAllPayment,
  getReceivingAccounts,
  getReceivingAccountsX,
  selectDNTPaymentMethod,
  selectHygMarketingPaymentMethod,
  selectHygPaymentMethod,
  selectHygPaymentMethodX,
} from '../../../actions/paymnetsAction';
import ProfilePaymentDNT from './ProfilePaymentDNT';

import { emailTemplate1, emailTemplate2 } from '../../../assets/emailTemplates';
import { createErrorMessageSelector, createLoadingSelector } from '../../../apis/selectors';
import LicenseCredentialTab from './LicenseCredentialTab';
import ReceiptList from './Receipts/ReceiptList';
import Invoices from './invoices';
import BlockedByOffices from './BlockedByOffices';
import UserReview from './UserReview';
import { OfficeReviews } from './OfficeReviews';
import UserMap from './Profile/UserMap';
import ProfileSkills from './ProfileSkills';
import MedMalSurvey from '../../commonComponents/MedMalSurvey';
import ResetPasswordPopup from './ResetPasswordPopup';
import { WorkerClassification } from '../../commonComponents/WorkerClassification';
import { toggleTabState } from './utils';

import StarIcon from '../../../images/star_Green.png';
import ToothIcon from '../../../images/HY_tooth.png';
import OfficeAvatarIcon from '../../../images/office-avatar.svg';
import { DetailHeader } from '../../commonComponents/DetailHeader';
import { Badges } from '../../commonComponents/Badges';
import HYGFavoritesList from '../../commonComponents/HYGFavoritesList';
import HighlyRatedList from '../../commonComponents/HighlyRatedList/HighlyRatedList';
import { fetchProfessionalLoyaltyLevel } from '../../../actions/metricsAction';
import { DNTTabs } from './DNTTabs/DNTTabs';
import { HYGTabs } from './HYGTabs/HYGTabs';
import { AvailabilityList } from '../../commonComponents/AvailabilityList/AvailabilityList';
import { getProfessionalAvailability } from '../../../actions/availabilityAction';
import { UserType } from '../../../enums/UserType';

import '../../../themes/Profile.scss';
import { GOVERNMENT_ID_STATUS } from '../../../enums/AccountStatus';
import { ProperksGiftCardRedemption } from '../../commonComponents/Properks/ProperksGiftCardRedemption';
import { ProperksProfessionalChallenge } from '../../commonComponents/Properks/ProperksProfessionalChallenge';
import { PromotionsTabScreen } from './Promotions';
import { CampaignsTabScreen } from './Campaigns';
import { GoTuFeedback } from './GoTuFeedback';
import { ProfessionalResume } from '../PermanentJobV2/ProfessionalResume';
import { UserPermanentJobListV2 } from '../PermanentJobV2/UserPermanentJobListV2';
import ACHAuthorization from './ACHAuthorization';
import { Spinner } from '../../commonComponents/Spinner';

// First, checks if it isn't implemented yet.
if (!String.prototype.format) {
  String.prototype.format = function () {
    const args = arguments;
    return this.replace(/{(\d+)}/g, (match, number) =>
      typeof args[number] !== 'undefined' ? args[number] : match,
    );
  };
}

class Profile extends Component {
  constructor(props) {
    super(props);

    this.textInput = React.createRef();

    this.state = {
      // all available tabs
      generalTab: true,
      licenses: false,
      skills: false,
      paymentTab: false,
      invoicesTab: false,
      jobsTab: false,
      offersTab: false,
      mapTab: false,
      editsTab: false,
      officeReciptsTab: false,
      blockedTab: false,
      npsTab: false,
      notesTab: false,
      childOfficesTab: false,
      reviewTab: false,
      medMalTab: false,
      ppJobsTab: false,
      permanentJobsTab: false,
      notificationsTab: false,
      favoritesTab: false,
      workerClassificationTab: false,
      highlyRatedTab: false,
      badgesTab: false,
      properksGiftCardsTab: false,
      properksChallengeTab: false,
      availabilityTab: false,
      promotionsTab: false,
      campaignsTab: false,
      gotuFeedbackTab: false,
      resumeTab: false,
      achAuthorizationTab: false,

      // screen states
      profileType: this.props.match.params.profileType,
      modalIsOpen: false,
      email: '',
      verify: false,
      deleted: false,
      emailSubject: 'Your TempMee account has been approved!',
      selectedEmail: '',
      showResetPasswordPopup: false,
      passwordResetCode: '',
      newPassword: '',
    };
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  async componentDidMount() {
    const {
      fetchCurrentUser,
      history,
      match,
      fetchStateCredentials,
      stateCredentials,
      fetchProfessionalLoyaltyLevel,
    } = this.props;

    const tabState = toggleTabState(match.params.currentTab);

    // if no tab is selected, redirect to general tab
    if (!Object.values(tabState).some((val) => val)) {
      history.replace(`/user/${match.params.profileType}/${match.params.id}`);
    }

    this.setState(tabState);

    if (JSON.stringify(stateCredentials) === '{}') {
      fetchStateCredentials();
    }

    const userProfileId =
      match.params.profileType && match.params.id
        ? match.params.id
        : history.location.state.user_id;

    await fetchCurrentUser(userProfileId, { init: true });
    fetchProfessionalLoyaltyLevel([userProfileId]);

    this.fetchData();
  }

  async componentDidUpdate(prevProps) {
    const { fetchCurrentUser, fetchProfessionalStats, history, match } = this.props;

    if (
      match.params.profileType !== prevProps.match.params.profileType ||
      match.params.id !== prevProps.match.params.id
    ) {
      await fetchCurrentUser(
        match.params.profileType && match.params.id
          ? match.params.id
          : history.location.state.user_id,
        { init: true }
      );
    }

    if (match.params.currentTab !== prevProps.match.params.currentTab) {
      const tabState = toggleTabState(match.params.currentTab);
      this.setState(tabState, () => {
        this.fetchData();
      });
    }

    if (
      this.props.userProfile?.id !== prevProps.userProfile?.id &&
      this.props.userProfile?.user_type === 'HYG'
    ) {
      fetchProfessionalStats(this.props.userProfile.id);
    }
  }

  fetchData = () => {
    const {
      userProfile,
      getReceivingAccounts,
      getReceivingAccountsX,
      getAllPayment,
      fetchUserNotes,
      fetchChildOffices,
      getUserOffers,
      getProfessionalAvailability,
    } = this.props;

    if (this.state.paymentTab) {
      if (userProfile?.user_type === 'HYG') {
        getReceivingAccounts();
        getReceivingAccountsX();
      } else {
        getAllPayment();
      }
    } else if (this.state.achAuthorizationTab) {
      // ACHAuthorization component fetches its own data
    } else if (this.state.notesTab) {
      fetchUserNotes(userProfile.id);
    } else if (this.state.childOfficesTab) {
      fetchChildOffices(userProfile.id);
    } else if (this.state.offersTab) {
      getUserOffers({
        userId: userProfile?.id,
        licenseTypes: userProfile?.licenseTypes,
      });
    } else if (this.state.generalTab) {
      if (userProfile?.user_type === UserType.HYG) {
        getProfessionalAvailability();
      }
    }
  };

  handleAvatarChange = async (event) => {
    if (!event.target.files[0]) {
      return;
    }

    new Compressor(event.target.files[0], {
      quality: 0.8, // 0.6 can also be used, but its not recommended to go below.
      maxWidth: 1024,
      maxHeight: 1024,
      success: (compressedResult) => {
        this.props.updateUserAvatar(compressedResult);
      },
      error(err) {
        console.log(err.message);
      },
    });
  };

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  afterOpenModal() {
    // references are now sync'd and can be accessed.
    this.subtitle.style.color = '#808080';
  }

  closeModal() {
    this.setState({ verify: false, modalIsOpen: false, deleted: false });
  }

  sendEmailAndNotification = () => {
    this.setState({
      modalIsOpen: false,
      verify: false,
    });
    const { selectedEmail, emailSubject } = this.state;
    this.props.sendEmail(emailSubject, selectedEmail);
  };

  deleteAccount = () => {
    this.setState({
      modalIsOpen: false,
      deleted: false,
    });
    // Send Delete Request
    this.props.deleteCurrentUser();
  };

  verify() {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <h2
          ref={(subtitle) => (this.subtitle = subtitle)}
          className={Styles.h3}
          style={{ fontSize: '24px' }}
        >
          Verification
        </h2>
        <div style={{ width: '80%' }}>
          <ReactQuill value={this.state.email} onChange={this.handleChange} theme="snow" />
        </div>
        <div
          style={{
            display: 'flex',
            width: '60%',
            justifyContent: 'space-between',
            marginTop: '20px',
          }}
        >
          <button
            className={Styles.btn_selected}
            style={{
              backgroundColor: 'red',
              width: '45%',
              height: '34px',
              margin: '0',
            }}
            onClick={this.closeModal}
            type="button"
          >
            Cancel
          </button>
          <button
            className={Styles.btn_selected}
            style={{
              backgroundColor: '#00DD00',
              width: '45%',
              height: '34px',
              margin: '0',
            }}
            type="submit"
            onClick={this.sendEmailAndNotification}
          >
            Send
          </button>
        </div>
      </div>
    );
  }

  showAccountStandingOptions() {
    return (
      <select
        className="custom-select custom-select-lg mb-3"
        style={{ marginTop: '5px', position: 'relative' }}
        value={this.props.userProfile?.account_standing}
        onChange={(e) => this.props.updateAccountStanding({ account_standing: e.target.value })}
      >
        <option className="dropdown-item" value="verified">
          Verified
        </option>
        <option className="dropdown-item" value="restricted">
          Restricted
        </option>
        <option className="dropdown-item" value="paused">
          Paused
        </option>
        <option className="dropdown-item" value="in-review">
          In Review
        </option>
        <option className="dropdown-item" value="blocked">
          Blocked
        </option>
      </select>
    );
  }

  showRamVerifiedOptions() {
    return (
      <select
        className="custom-select custom-select-lg mb-3"
        style={{ marginTop: '5px', position: 'relative' }}
        value={this.props.userProfile?.office_info?.ramVerified}
        onChange={(e) =>
          this.props.updateRamVerifiedStatus({
            ramVerified: e.target.value,
          })
        }
        disabled={this.props.userProfile?.office_info?.ramVerified === 'verified'}
      >
        <option className="dropdown-item" value="verified">
          Verified
        </option>
        <option className="dropdown-item" value="unverified">
          Unverified
        </option>
        <option className="dropdown-item" value="fake">
          Fake
        </option>
      </select>
    );
  }

  handleSubjectChange = (event) => {
    this.setState({ emailSubject: event.target.value });
  };

  handleChange = (value) => {
    this.setState({ selectedEmail: value });
  };

  openVerify = () => {
    this.setState({ verify: true, modalIsOpen: true });
  };

  openDelete = () => {
    this.setState({ deleted: true, modalIsOpen: true });
  };

  showVerify() {
    return (
      <LegacyDialogBody>
        <h2
          ref={(subtitle) => (this.subtitle = subtitle)}
          className={Styles.h3}
          style={{ fontSize: '24px' }}
        >
          Verification
        </h2>

        <div
          style={{
            width: '80%',
            padding: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <input
            className="form-control mb-1"
            style={{ width: '100%' }}
            value={this.state.emailSubject}
            type="text"
            onChange={(e) => this.handleSubjectChange(e)}
          />
        </div>

        <div style={{ width: '80%' }}>
          <ReactQuill
            intialValue=""
            value={this.state.selectedEmail}
            onChange={(content) => this.handleChange(content)}
            theme="snow"
          />
        </div>
        {this.emailTemplateSelection()}
        <div
          style={{
            display: 'flex',
            width: '60%',
            justifyContent: 'space-between',
            marginTop: '20px',
          }}
        >
          <button
            className="btn btn-info"
            style={{
              backgroundColor: 'red',
              width: '45%',
              height: '34px',
              margin: '0',
            }}
            type="button"
            onClick={this.closeModal}
          >
            Cancel
          </button>
          <button
            className="btn btn-info"
            style={{
              backgroundColor: '#00DD00',
              width: '45%',
              height: '34px',
              margin: '0',
            }}
            type="submit"
            onClick={this.sendEmailAndNotification}
          >
            Send
          </button>
        </div>
      </LegacyDialogBody>
    );
  }

  emailTemplateSelection() {
    return (
      <div style={{ display: 'flex' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <input
            style={{ margin: 0 }}
            type="radio"
            id="huey"
            name="drone"
            value="0"
            onChange={(e) => this.changeTemplate(e.target.value)}
          />
          <label style={{ margin: 0, paddingLeft: 5 }}>Email 1</label>
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            marginLeft: 5,
          }}
        >
          <input
            style={{ margin: 0 }}
            type="radio"
            id="black"
            name="drone"
            value="1"
            onChange={(e) => this.changeTemplate(e.target.value)}
          />
          <label style={{ margin: 0, paddingLeft: 5 }}>Email 2</label>
        </div>
      </div>
    );
  }

  changeTemplate(template) {
    const templateArr = [
      emailTemplate1.format(this.props.userProfile.first_name),
      emailTemplate2().format(this.props.userProfile.first_name),
    ];
    this.setState({ selectedEmail: templateArr[Number(template)] });
  }

  showDeleted() {
    return (
      <LegacyDialogBody>
        <h2
          ref={(subtitle) => (this.subtitle = subtitle)}
          className={Styles.h3}
          style={{ fontSize: '24px' }}
        >
          Delete Account?
        </h2>
        <div style={{ width: '80%' }}>
          <h3 className={Styles.h3} style={{ fontSize: '20px', textAlign: 'center' }}>
            Are you sure you want to delete this account?
          </h3>
        </div>
        <div
          style={{
            display: 'flex',
            width: '60%',
            justifyContent: 'space-between',
            marginTop: '20px',
          }}
        >
          <button
            className="btn btn-info"
            style={{
              backgroundColor: 'gray',
              width: '45%',
              height: '34px',
              margin: '0',
            }}
            onClick={() => this.closeModal()}
          >
            Cancel
          </button>
          <button
            className="btn btn-info"
            style={{
              backgroundColor: 'red',
              width: '45%',
              height: '34px',
              margin: '0',
            }}
            onClick={() => this.deleteAccount()}
          >
            Delete
          </button>
        </div>
      </LegacyDialogBody>
    );
  }

  paymentDNT() {
    const {
      allPaymentMethods,
      userProfile,
      selectDNTPaymentMethod,
      updateCurrentUserPayment,
      isPreApproveUser,
    } = this.props;

    return (
      <ProfilePaymentDNT
        accounts={allPaymentMethods}
        isPaymentSelected={(id) => selectDNTPaymentMethod(id)}
        preApproved={userProfile.is_pre_approved}
        onPreApprovedChanged={(isPreApproved) => {
          updateCurrentUserPayment({ is_pre_approved: isPreApproved === 'true' });
        }}
        onReceiptEnabledChanged={(isReceiptEnabled) => {
          updateCurrentUserPayment({ receipt_enabled: isReceiptEnabled });
        }}
        receiptEnabled={userProfile.receipt_enabled}
        preApproveUser={isPreApproveUser}
      />
    );
  }

  paymentHYG() {
    const {
      allPaymentMethods,
      allPaymentMethodsX,
      selectHygPaymentMethod,
      selectHygPaymentMethodX,
      allPaymentMethodsForReferral,
      selectHygMarketingPaymentMethod,
    } = this.props;

    return (
      <div
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-evenly',
          alignItems: 'center',
          marginTop: '25px',
          marginBottom: '100px',
        }}
      >
        <div
          className="card"
          style={{
            margin: 25,
            width: '60%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <h3
            className="card-title"
            style={{
              fontFamily: 'Nunito',
              fontWeight: 700,
              textAlign: 'center',
              color: '#435963',
            }}
          >
            Payment Methods GoTu Tech
          </h3>
          <CustomPaymentMethodsList
            accounts={allPaymentMethods || []}
            isPaymentSelected={(id) => selectHygPaymentMethod(id)}
          />
        </div>
        <div
          className="card"
          style={{
            margin: 25,
            width: '60%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <h3
            className="card-title"
            style={{
              fontFamily: 'Nunito',
              fontWeight: 700,
              textAlign: 'center',
              color: '#435963',
            }}
          >
            Payment Methods GoTu X
          </h3>
          <CustomPaymentMethodsList
            accounts={allPaymentMethodsX || []}
            isPaymentSelected={(id) => selectHygPaymentMethodX(id)}
          />
        </div>
        <div
          className="card"
          style={{
            margin: 25,
            width: '60%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <h3
            className="card-title"
            style={{
              fontFamily: 'Nunito',
              fontWeight: 700,
              textAlign: 'center',
              color: '#435963',
            }}
          >
            Marketing Payment Methods
          </h3>
          <CustomPaymentMethodsList
            accounts={allPaymentMethodsForReferral || []}
            isPaymentSelected={(id) => selectHygMarketingPaymentMethod(id)}
          />
        </div>
      </div>
    );
  }

  blockedHygienist() {
    if (this.props.userProfile) {
      return <BlockedHygienist dentist={this.props.userProfile} history={this.props.history} />;
    }

    return <div />;
  }

  changeTab(tab) {
    const { userProfile, history, match } = this.props;
    const { profileType } = this.state;

    const newTab = tab === 'general' ? '' : tab;

    // if change to the same tab, reload data
    if (match.params.currentTab === newTab) {
      this.fetchData();
    } else {
      history.push(`/user/${profileType}/${userProfile?.id}/${newTab}`);
    }
  }

  goToJobProfile = (job) => this.props.history.push(`/job/${job.id}`, { job_id: job.id });

  updateStateId = async (image) => {
    if (!image) {
      return;
    }
    new Compressor(image, {
      quality: 0.8, // 0.6 can also be used, but its not recommended to go below.
      maxWidth: 1024,
      maxHeight: 1024,
      success: (compressedResult) => {
        this.props.updateUserPicture(compressedResult);
      },
      error(err) {
        console.log(err.message);
      },
    });
  };

  tabSelection = () => {
    const { isLoading, userProfile, newStateId, addUserNote, updateCurrentUser } = this.props;

    if (isLoading) {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Spinner />
        </div>
      );
    }
    if (this.state.jobsTab) {
      return <UserJobList />;
    }
    if (this.state.offersTab) {
      return <UserOfferList />;
    }

    if (userProfile?.user_type === 'HYG') {
      if (this.state.generalTab) {
        return this.hygienistProfile();
      }

      if (this.state.licenses) {
        return (
          <LicenseCredentialTab
            user_profile={userProfile}
            allProfessions={this.props.allProfessions}
            onSaveClicked={({ stateIdStatus }) => {
              updateCurrentUser({
                hyg_ident_status: stateIdStatus,
              });
            }}
            stateCredentials={this.props.stateCredentials}
          />
        );
      }
      if (this.state.skills) {
        return <ProfileSkills />;
      }
      if (this.state.paymentTab) {
        return this.paymentHYG();
      }

      if (this.state.npsTab) {
        return <NPSInfo npsInfo={userProfile.nps_reviews} />;
      }

      if (this.state.editsTab) {
        return <EditTab editList={userProfile?.edits} isUserEdits professionalId={userProfile?.id} />;
      }
      if (this.state.notesTab) {
        return (
          <NotesTab
            notes={userProfile?.notes || []}
            userId={userProfile?.id}
            submitNote={addUserNote}
            currentUser={userProfile}
            isProfessional
          />
        );
      }
      if (this.state.blockedTab) {
        return <BlockedByOffices />;
      }
      if (this.state.reviewTab) {
        return <UserReview goToJobProfile={this.goToJobProfile} />;
      }
      if (this.state.mapTab) {
        return <UserMap />;
      }
      if (this.state.notificationsTab) {
        return <NotificationSettingsHYG />;
      }
      if (this.state.medMalTab) {
        return <MedMalSurvey />;
      }
      if (this.state.badgesTab) {
        return <Badges />;
      }
      if (this.state.properksGiftCardsTab) {
        return <ProperksGiftCardRedemption />;
      }
      if (this.state.properksChallengeTab) {
        return <ProperksProfessionalChallenge />;
      }
      if (this.state.favoritesTab) {
        return <HYGFavoritesList />;
      }
      if (this.state.resumeTab) {
        return <ProfessionalResume />;
      }
    } else {
      if (this.state.generalTab) {
        return this.dentistProfile();
      }
      if (this.state.paymentTab) {
        return this.paymentDNT();
      }
      if (this.state.achAuthorizationTab) {
        return <ACHAuthorization />;
      }
      if (this.state.invoicesTab) {
        return <Invoices />;
      }
      if (this.state.npsTab) {
        return <NPSInfo npsInfo={userProfile.nps_reviews} />;
      }
      if (this.state.ppJobsTab) {
        return <UserPPJobList />;
      }
      if (this.state.permanentJobsTab) {
        return <UserPermanentJobListV2 />;
      }
      if (this.state.notificationsTab) {
        return <NotificationSettings />;
      }
      if (this.state.favoritesTab) {
        return <FavoritesList />;
      }

      if (this.state.workerClassificationTab) {
        return <WorkerClassification />;
      }
      if (this.state.highlyRatedTab) {
        return <HighlyRatedList />;
      }
      if (this.state.blockedTab) {
        return this.blockedHygienist();
      }
      if (this.state.editsTab) {
        return <EditTab editList={userProfile?.edits} isUserEdits professionalId={userProfile?.id} />;
      }
      if (this.state.notesTab) {
        return (
          <NotesTab
            notes={userProfile?.notes || []}
            userId={userProfile?.id}
            submitNote={addUserNote}
          />
        );
      }
      if (this.state.childOfficesTab) {
        return <ChildOffices />;
      }
      if (this.state.officeReciptsTab) {
        return <ReceiptList />;
      }
      if (this.state.reviewTab) {
        // Offices read organization-service; professionals keep UserReview on the
        // monolith, which is the only endpoint carrying office->professional
        // reviews. Two components rather than one branching on user_type, so an
        // office-side change cannot reach the professional tab.
        return <OfficeReviews officeId={userProfile?.id} />;
      }
      if (this.state.mapTab) {
        return <UserMap />;
      }
      if (this.state.availabilityTab) {
        return <AvailabilityList />;
      }
    }

    if (this.state.gotuFeedbackTab) {
      return <GoTuFeedback />;
    }

    if (this.state.promotionsTab) {
      return <PromotionsTabScreen />;
    }

    if (this.state.campaignsTab) {
      return <CampaignsTabScreen />;
    }
  };

  hygienistProfile() {
    return <ProfileHygienistGeneralInfo openVerify={this.openVerify} />;
  }

  dentistProfile() {
    return <ProfileDentistGeneralInfo openVerify={this.openVerify} />;
  }

  getUserTitle() {
    const { userProfile, cityOfUserAddress } = this.props;
    const { first_name: firstName, last_name: lastName } = userProfile || {};

    if (!userProfile) {
      return '';
    }

    if (userProfile?.user_type === 'HYG') {
      return `DENTAL PROFESSIONAL | ${firstName || ''} ${lastName || ''} | ${cityOfUserAddress}`;
    }

    return `${userProfile?.office_name || ''} | ${cityOfUserAddress}`;
  }

  // Sits beside the title rather than inside it. As part of the <h2> the star
  // was a 30px inline image that wrapped the name onto three lines, which was
  // most of the banner's height.
  getUserMeta() {
    const { userProfile } = this.props;

    if (userProfile?.user_type !== 'DNT' || !userProfile?.average_rating) {
      return null;
    }

    return (
      <>
        <img src={StarIcon} width="20" height="20" alt="" />
        {userProfile.average_rating.toFixed(1)}
      </>
    );
  }

  renderProfessionalStats() {
    const {
      userProfile,
      totalCompletedCount,
      totalLateCancellationCount,
      totalNoShowCount,
      attendancePercentage,
      averageRating,
    } = this.props;

    const totalShifts = totalCompletedCount + totalNoShowCount + totalLateCancellationCount;

    if (userProfile?.user_type !== 'HYG') {
      return <></>;
    }

    const statsCard = ({ title, value }) => (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: 154,
          backgroundColor: 'white',
          border: '1px solid #DDDDDD',
        }}
      >
        <h2 style={{ fontSize: 24, marginTop: 10, marginBottom: 3 }}>{value}</h2>

        <p>{title}</p>
      </div>
    );

    return (
      <div
        style={{
          display: 'flex',
          columnGap: 5,
          marginTop: 20,
          marginBottom: 15,
        }}
      >
        {statsCard({ title: 'Total Shifts', value: totalShifts })}
        {statsCard({ title: 'Completed Shifts', value: totalCompletedCount })}
        {statsCard({ title: 'Late Cancels', value: totalLateCancellationCount })}
        {statsCard({ title: 'No Shows', value: totalNoShowCount })}
        {statsCard({
          title: 'Attendance Score',
          value: attendancePercentage ? `${attendancePercentage}%` : '-',
        })}
        {statsCard({
          title: 'AVG Rating',
          value: averageRating?.toFixed(1) ?? '-',
        })}
      </div>
    );
  }

  profileComplete() {
    const { userProfile, sendUserMFA, adminUser } = this.props;

    if (userProfile?.user_type === 'HYG') {
      return (
        <>
          {userProfile?.is_profile_complete &&
          // eslint-disable-next-line max-len
          userProfile?.professional_info?.government_id?.status ===
            GOVERNMENT_ID_STATUS.VERIFIED ? (
              <p
              style={{
                color: 'green',
                fontWeight: 'bold',
                marginRight: '30px',
                marginTop: '10px',
              }}
            >
                Profile Complete
              </p>
          ) : (
            <>
              {userProfile?.is_profile_complete ? null : (
                <button
                  disabled={!!userProfile?.is_profile_complete}
                  style={{ width: '150px', height: 44 }}
                  className={
                    userProfile?.is_profile_complete
                      ? 'btn btn-secondary mr-4'
                      : 'btn btn-success mr-4'
                  }
                  onClick={() => this.props.updateCurrentUser({ is_profile_complete: true })}
                >
                  Finish sign up
                </button>
              )}
            </>
          )}
        </>
      );
    }
    if (userProfile?.user_type === 'DNT') {
      return (
        <>
          {adminUser?.email_id === process.env.REACT_APP_ADMIN_EMAIL_RESET_PASSWORD ? (
            <button
              style={{ width: '130px', height: 44, marginRight: 25 }}
              className="btn btn-info"
              onClick={() => {
                sendUserMFA();
                this.setState({ showResetPasswordPopup: true });
              }}
            >
              Reset password
            </button>
          ) : (
            <div />
          )}
          {userProfile?.is_profile_complete ? (
            <p
              style={{
                color: 'green',
                fontWeight: 'bold',
                marginRight: '30px',
                marginTop: '10px',
              }}
            >
              Profile Complete
            </p>
          ) : (
            <button
              disabled={!!userProfile?.is_profile_complete}
              style={{ width: '150px', height: 44 }}
              className={
                userProfile?.is_profile_complete ? 'btn btn-secondary mr-4' : 'btn btn-success mr-4'
              }
              onClick={() => this.props.updateCurrentUser({ is_profile_complete: true })}
            >
              Finish sign up
            </button>
          )}
        </>
      );
    }
  }

  renderDefaultProfilePicture() {
    const { userProfile } = this.props;

    if (!userProfile) {
      return <div />;
    }

    if (userProfile?.user_type === 'DNT') {
      return (
        <img
          src={OfficeAvatarIcon}
          alt="default_user_pic"
          className={Styles.profile_image_office}
        />
      );
    }

    // Reached only for non-DNT, so the icon is always the tooth.
    return (
      <div className={Styles.profile_image_default_circle}>
        <img src={ToothIcon} alt="default_user_pic" className={Styles.profile_image_default} />
      </div>
    );
  }

  renderAvatar() {
    const { userProfile } = this.props;

    return (
      <div onClick={() => this.textInput.current.click()}>
        <input
          ref={this.textInput}
          style={{ display: 'none' }}
          type="file"
          onChange={(e) => this.handleAvatarChange(e)}
        />
        {userProfile?.profile_image ? (
          <img src={userProfile?.profile_image} alt="profile" className={Styles.profile_image} />
        ) : (
          this.renderDefaultProfilePicture()
        )}
      </div>
    );
  }

  render() {
    const { userProfile, isLoading, resetUserPassword, match } = this.props;

    return (
      <div
        // Fills the content column, not the viewport. This was `width: 100vw`
        // and `height: calc(100vh - 102px)`, which both assumed the page ran
        // full-bleed under a 102px-tall top navbar. Inside the sidebar layout
        // 100vw is too wide by the width of the rail — that surplus pushed the
        // page into horizontal overflow — and the 102px offset no longer
        // matches any real chrome.
        style={{
          width: '100%',
          height: '100%',
          overflowY: 'auto',
          overflowX: 'hidden',
        }}
        className="bg-light"
        id="profile-content"
      >
        <DetailHeader
          tone={userProfile?.user_type === 'DNT' ? 'neutral' : 'primary'}
          avatar={this.renderAvatar()}
          title={this.getUserTitle()}
          meta={this.getUserMeta()}
        />

        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            backgroundColor: '#FAFAFA',
            margin: 0,
            marginBottom: 30,
          }}
        >
          {!isLoading ? (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
              }}
            >
              <div
                className="card border-0 bg-transparent mr-2"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'column',
                }}
              >
                {this.renderProfessionalStats()}

                <div
                  className="card-body"
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                  }}
                >
                  {this.profileComplete()}
                  {userProfile?.user_type === 'DNT' &&
                    userProfile?.parent_office && (
                      <button
                        style={{ width: 200, height: 44 }}
                        className="btn btn-info mr-4"
                        onClick={() =>
                          this.props.history.push(`/user/dentist/${userProfile?.parent_office}`)
                        }
                      >
                        Open Parent Account
                      </button>
                    )}
                  <button
                    className="btn btn-danger mr-4"
                    style={{ width: '150px', height: 44 }}
                    onClick={() => this.openDelete()}
                  >
                    Permanently Delete
                  </button>
                  <div
                    className="mr-4"
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: 150,
                    }}
                  >
                    <h4 className="card-title">Account Status: </h4>
                    {this.showAccountStandingOptions()}
                  </div>
                  {userProfile?.user_type === 'DNT' && (
                    <div
                      className="mr-4"
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 150,
                      }}
                    >
                      <h4 className="card-title">RAM Verified: </h4>
                      {this.showRamVerifiedOptions()}
                    </div>
                  )}
                </div>
              </div>
              {userProfile?.professional_info?.government_id?.status !==
                GOVERNMENT_ID_STATUS.VERIFIED && userProfile?.user_type === 'HYG' ? (
                  <p style={{ color: 'red' }}>
                    To complete your profile registration, go to the Government I.D. and verify it
                  </p>
              ) : null}
              {userProfile?.user_type === 'DNT' ? (
                <DNTTabs
                  value={match?.params?.currentTab || ''}
                  onValueChanged={(value) => this.changeTab(value)}
                />
              ) : (
                <HYGTabs
                  value={match?.params?.currentTab || ''}
                  onValueChanged={(value) => this.changeTab(value)}
                  userProfile={userProfile}
                />
              )}
              <div
                // 100% not 100vw — see the note on #profile-content above.
                style={{
                  position: 'relative',
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  marginBottom: 100,
                }}
              >
                {this.tabSelection()}
              </div>
            </div>
          ) : (
            <Spinner />
          )}
        </div>

        <Dialog
          open={this.state.modalIsOpen}
          onClose={this.closeModal}
          size="medium"
        >
          {this.state.verify ? this.showVerify() : <div />}
          {this.state.deleted ? this.showDeleted() : <div />}
        </Dialog>

        <ResetPasswordPopup
          state={this.state}
          setState={(data) => this.setState(data)}
          resetUserPassword={resetUserPassword}
        />
      </div>
    );
  }
}

const actions = [
  'GET_ALL_PAYMENT',
  'HYG_GET_ALL_PAYMENT',
  'SELECT_CARD_PAYMENT',
  'FETCH_CURRENT_USER',
  'SEND_EMAIL',
  'UPDATE_USER_AVATAR',
  'GET_USER_RECEIPT_PDF',
  'UPDATE_USER_STATE',
  'FETCH_CHILD_OFFICES',
  'FETCH_USER_PP_JOBS',
  'FETCH_HYG_LOYALTY_LEVEL',
];
const loadingSelector = createLoadingSelector(actions);
const errorSelector = createErrorMessageSelector(actions);

const mapStateToProps = (state) => {
  const { users } = state || {};
  const city = users?.currentUser?.address?.[0]?.city || '';

  return {
    userProfile: users.currentUser,
    cityOfUserAddress: city,
    allPaymentMethods: state.payments.allPaymentMethods,
    allPaymentMethodsX: state.payments.allPaymentMethodsX,
    allPaymentMethodsForReferral: state.payments.allPaymentMethodsForReferral,
    isLoading: loadingSelector(state),
    error: errorSelector(state),
    userJobs: users.userJobs,
    receiptsJobs: users.receiptsJobs,
    receiptsPdfJobs: users.receiptsPdfJobs,
    officeReceipts: users.officeReceipts,
    searchParams: users.searchParams,
    totalJobsCount: users.totalJobsCount,
    adminUser: users.adminUser,
    totalPPJobsCount: users.totalPPJobsCount,
    newStateId: users.newStateId,
    isPreApproveUser: users.isPreApproveUser,
    stateCredentials: state.license.stateCredentials,
    allProfessions: state.jobs.allProfessions,
    totalNoShowCount: users.totalNoShowCount,
    totalCompletedCount: users.totalCompletedCount,
    totalLateCancellationCount: users.totalLateCancellationCount,
    attendancePercentage: users.attendancePercentage,
    averageRating: users.averageRating,
  };
};

export default connect(mapStateToProps, {
  deleteCurrentUser,
  fetchSpecificUser,
  fetchCurrentUser,
  setCurrentUser,
  updateAccountStanding,
  updateCurrentUser,
  updateCurrentUserPayment,
  selectHygPaymentMethod,
  selectHygPaymentMethodX,
  selectHygMarketingPaymentMethod,
  selectDNTPaymentMethod,
  getAllPayment,
  getReceivingAccounts,
  getReceivingAccountsX,
  getUserOffers,
  sendEmail,
  sendUserMFA,
  resetUserPassword,
  updateUserAvatar,
  fetchUserNotes,
  fetchChildOffices,
  addUserNote,
  updateUserPicture,
  getUserReceipts,
  fetchUsersAround,
  fetchStateCredentials,
  fetchProfessionalStats,
  updateRamVerifiedStatus,

  // data user inside `LoyaltyCardGroup` component
  fetchProfessionalLoyaltyLevel,

  getProfessionalAvailability,
})(Profile);
